import type { PayloadAction } from '@reduxjs/toolkit';

import type { NavigationStateStore } from '../types';

export const removeState = (state: NavigationStateStore, action: PayloadAction<string>) => {
  delete state[action.payload];
};
